import styled from 'styled-components'

interface ProgressProps {
  children?: React.ReactNode
  className?: string
}

export const Progress = ({ children, className }: ProgressProps) => (
  <ProgressDiv className={className}>{children}</ProgressDiv>
)

const ProgressDiv = styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 0.25rem;
  background-color: ${({ theme }) => theme.color.background.base.neutral.soft};
`

interface ProgresssBarProps {
  min?: number
  max?: number
  value: number
  transform?: `scaleX(${number})`
  className?: string
  name?: string
}

export const ProgressBar = ({
  min = 0,
  max = 100,
  value = 0,
  transform,
  className,
  name = '',
}: ProgresssBarProps) => {
  const clampedValue = Math.max(Math.min(value, max), min)
  return (
    <ProgressBarDiv
      role="progressbar"
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={clampedValue}
      aria-label={name ? `${name} progress bar` : 'progress bar'}
      $transform={transform}
      value={clampedValue}
      className={className}
    />
  )
}

const ProgressBarDiv = styled.div<{
  value: ProgresssBarProps['value']
  $transform?: ProgresssBarProps['transform']
}>`
  color: ${({ theme }) => theme.white};
  width: 100%;
  height: 0.5rem;
  display: flex;
  animation: none;
  flex-flow: column nowrap;
  text-align: center;
  justify-content: center;
  transform: ${({ value, $transform }) => $transform ?? `scaleX(${value / 100})`};
  transform-origin: top left;
  transition: transform 250ms ease;
  background: ${({ theme }) => theme.color.background.base.brand.primary};
`
